<template>
    <div class="" :class="{selected: selected}">
        <div class="name pt-2">{{name}}</div>
        <div class="value pb-2">{{value}}</div>
    </div>
</template>

<script>
/* tslint:disable */

    export default {
        name: "Value",
        props: ['name','value','selected']
    }
</script>

<style scoped lang="scss">
    .name {
        font-size: 0.7em;
        font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif;
        color: gray;
        text-transform: uppercase;
    }
    .value {
        font-size: 0.9em;
        font-family: 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif;
        font-weight: bold;
    }
    .selected {
        border-color: get('colors.Secondary');
        background-color: get('colors.Secondary');
        color: white;
    }

    .selected * {
        border-color: get('colors.Secondary');
        background-color: get('colors.Secondary');
        color: white;
    }
    .item:hover {
        border-color: get('colors.Secondary');
        color: white;
        background-color: get('colors.Secondary');
        cursor: pointer;
    }
    .item:hover * {
        color: white;
        background-color: get('colors.Secondary');
    }
</style>